export const propertiesNavItem = {
  key: 'properties',
  label: 'Properties',
  path: '/properties',
  propertyCatalog: true,
};

export function visibleNavItems(items, access) {
  const isSuperAdmin = access === true || Boolean(access?.isSuperAdmin);
  const canManagePropertyCatalog = access === true || Boolean(access?.canManagePropertyCatalog);
  return items.filter(item => {
    if (item.propertyCatalog) return canManagePropertyCatalog;
    return !item.superAdminOnly || isSuperAdmin;
  });
}

export function propertyCatalogHome(canManagePropertyCatalog) {
  return canManagePropertyCatalog ? null : '/dashboard';
}

export function filterPropertyCatalog(rows, query) {
  const q = String(query || '')
    .trim()
    .toLowerCase();
  if (!q) return rows;
  return rows.filter(row => {
    const name = String(row.name || '').toLowerCase();
    const abbreviation = String(row.abbreviation || '').toLowerCase();
    return name.includes(q) || abbreviation.includes(q);
  });
}

export function formatCityState(row) {
  return [row.city, row.state].filter(Boolean).join(', ');
}

export function activeOnRequest(property) {
  if (!String(property.payeeId || '').trim()) {
    return { dialog: 'payee' };
  }
  return { patch: { isActive: true } };
}

export function submitPayeeActivation({ payeeId, affordableHousing }) {
  return {
    isActive: true,
    payeeId: String(payeeId || '').trim(),
    affordableHousing: affordableHousing === true,
  };
}

export function activeOffConfirmBody(propertyName) {
  return `${propertyName} leaves the dropdown and the resident portal and payments stop.`;
}

export function beginActiveOff(property) {
  return {
    id: property.id,
    propertyName: property.name,
    body: activeOffConfirmBody(property.name),
    patch: null,
  };
}

export function confirmActiveOff() {
  return { isActive: false, canSync: false };
}

export function syncSwitchDisabled(property) {
  return !property?.isActive;
}

export function inactiveSyncClears(rows) {
  return (rows || []).filter(row => !row.isActive && row.canSync).map(row => ({ id: row.id, body: syncOffPatch() }));
}

export function syncOnChoices() {
  return [
    { id: 'now', label: 'Right now', patch: { canSync: true, syncNow: true } },
    { id: 'scheduled', label: 'Next scheduled sync', patch: { canSync: true } },
  ];
}

export function syncOffPatch() {
  return { canSync: false };
}

export function payeeEditPatch(payeeId) {
  const trimmed = String(payeeId ?? '').trim();
  if (!/^\d+$/.test(trimmed)) {
    return { error: 'Paylease ID must be a numeric string' };
  }
  return { patch: { payeeId: trimmed } };
}

export function housingTypePatch(affordableHousing) {
  return { affordableHousing: affordableHousing === true };
}

export function flagPatch(field, enabled) {
  return { [field]: enabled === true };
}

export const propertySettingGroups = [
  {
    id: 'application-flow',
    label: 'Application flow',
    flags: [
      { field: 'payBefore', label: 'Pay before' },
      { field: 'isIdentityVerificationEnabled', label: 'Identity verification' },
      { field: 'isProofupVerificationEnabled', label: 'ProofUp', housing: 'conventional' },
      { field: 'affordableDocumentUploadOptional', label: 'Optional document upload', housing: 'affordable' },
    ],
  },
  {
    id: 'other',
    label: '',
    flags: [
      { field: 'allowCustomPayment', label: 'Custom payment' },
      { field: 'customPaymentMinDue', label: 'Custom payment minimum due', requires: 'allowCustomPayment' },
      { field: 'selfServiceRenewalEnabled', label: 'Self-service renewal', housing: 'conventional' },
    ],
  },
];

export const propertySettingFlags = propertySettingGroups.flatMap(group => group.flags);

function flagVisible(flag, affordable) {
  if (flag.housing === 'affordable') return affordable;
  if (flag.housing === 'conventional') return !affordable;
  return true;
}

export function settingGroupsForProperty(property) {
  const affordable = property?.affordableHousing === true;
  return propertySettingGroups
    .map(group => ({
      ...group,
      flags: group.flags.filter(flag => flagVisible(flag, affordable)).map(flag => ({
        ...flag,
        enabled: !flag.requires || property?.[flag.requires] === true,
      })),
    }))
    .filter(group => group.flags.length > 0);
}
